export enum STORAGE_PREFRENCES_KEYS {
  AUDIO_ENABLED = "AUDIO_ENABLED",
  MUSIC_ENABLED = "MUSIC_ENABLED",
}
